import React, {useState, useEffect, useContext} from "react"
import { withTranslation, WithTranslation, useTranslation } from "react-i18next";

import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';

import {  validateRules,
          getRulesOptions, 
          NodeType, 
          ConditionNode, 
          AddNode, 
          StatementNode,
          extraTranslations,
          resetValidationResult,
          interviewTranslations } from './RulesData';

import SvgIcon from '@material-ui/core/SvgIcon';
import TreeView from "@material-ui/lab/TreeView";
import TreeItem, { TreeItemProps } from "@material-ui/lab/TreeItem";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { fade, withStyles } from '@material-ui/core/styles';
import { useSpring, animated } from 'react-spring/web.cjs';
import Collapse from '@material-ui/core/Collapse';

import  RuleCondtion  from './RuleCondtion';
import  AddRuleNode  from './AddNode';
import RuleStatement from './RuleStatement';
import GlobalRulesContext from './RulesContext';
import Dropdown from "react-dropdown";


export interface TreeItemData {
  id: string;
  name: string;
  children: TreeItemData[];
}

interface DataTreeViewProps {
  treeItems: NodeType[];
  stepsList: Array<any>;
}

let getRulesData = (list: any): Array<NodeType> =>{
  let rulesDataList: Array<NodeType>;
  let condNode;
  let addNode;

  // list = JSON.parse('{"conditions":{"all":[{"fact":"BP","operator":"notEqual","value":"upperLimit_marginal"},{"fact":"BT","operator":"lessThan","value":"upperLimit_marginal"},{"any":[{"fact":"WT","operator":"notEqual","value":"upperLimit_marginal"},{"fact":"BG","operator":"lessThan","value":"lowerLimit_significant"}]}]}}');
  
  if (list == null || 
      list == undefined || 
      !list.conditions ||
      list.conditions.length <= 0 ) {
    condNode = new ConditionNode(uuid(), null);
    addNode = new AddNode(uuid(), "");
    condNode.addChild(addNode);
    rulesDataList = [
     condNode
    ];
  } else {
    rulesDataList = [getRulesFromObject(list)];
  }
  return rulesDataList;
}

// Form tree structure from json rules data
const getRulesFromObject = (rulesListData) => {
  let root;
  let condNode;
  let addNode;
  if (rulesListData.conditions ) {
    let isConditionNode = false;
    root = rulesListData.conditions;
    let keyName = null;
    if (root.all != undefined) {
      isConditionNode = true;
      keyName = "all";
    } else if (root.any != undefined) {
      isConditionNode = true;
      keyName = "any";
    }
    if (keyName) {
      condNode = new ConditionNode(uuid(), keyName);
      addNode = new AddNode(uuid(), "");
      condNode.addChild(addNode);
    }

    if (isConditionNode) {
      for (let statement of root[keyName]) {
        if (statement.fact != undefined) {
          let factName = statement.fact;
          let operator;
          let rhs;
          if (statement.operator != undefined) {
            operator = statement.operator;
          }
          if (statement.value != undefined) {
            rhs = statement.value;
          }
          let statementNode = new StatementNode(uuid(), factName, operator, rhs);
          condNode.addChild(statementNode);
        } else {
          let subCondNode = getRulesFromObject({conditions: statement});
          condNode.addChild(subCondNode);
        }
      }
    }
  }
  return condNode;
}

const MinusSquare = (props) => {
  return (

    <ExpandMoreIcon style={{ fontSize: 25, color: "#0080FF" }} {...props}/>
  );
}

const PlusSquare = (props) => {
  return (
    <ChevronRightIcon style={{ fontSize: 25, color: "#0080FF" }} {...props}/>
  );
}

const CloseSquare = (props) => {
  return (
    <svg className="icon">
      <g fill="none" stroke="black" strokeWidth="2">  
        <path strokeDasharray="60,4" d="M4 20 l440 10" />
      </g>
    </svg>
  );
}

const TransitionComponent = (props) => {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: 1, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });
  const [isCollapsed, setCollapsed] = useState(true);
  useEffect(() => {
    props.in == 0 ? setCollapsed(true) : setCollapsed(false); 
  },[props.in]);
  return (
    <animated.div style={style}>
      <Collapse {...props} />
      {isCollapsed == true ? <div style={{opacity: 1, marginLeft: -7, borderLeft: `1px solid black`, height: 10, width: 4}}></div> : ""}
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': { opacity: 0.3 },
  },
  content: {
    backgroundColor: "#d3d3d3",
    paddingLeft: 7,
    borderRadius: 2,
    marginTop: 3,
  },
  root: {
    marginLeft: 12,
  },
  group: {
    marginLeft: 13,
    paddingBottom: 10,
    paddingTop: 10,
    borderLeft: `1px solid black`,
  },
}))((props: TreeItemProps) => ( // Wrapping TreeItem here while preserving all original props like nodeId (prevent Typescript from erroring out with missing nodeId error).
  <TreeItem {...props} TransitionComponent={TransitionComponent} />
));

var interviewSteps = [];



const getTreeItemsFromRules = (rulesList: Array<any>, stepsInfo: Array<any>, localeCode: string, translationIds: Array<any>, translations: Array<any>, measurement_translations: Array<any>) => {
  return rulesList.map((ruleData) => {
    if (ruleData) {
      let children = undefined;
      if (ruleData.children && ruleData.children.length > 0) {
        children = getTreeItemsFromRules(ruleData.children, stepsInfo, localeCode, translationIds, translations, measurement_translations);
      }
      let labelComponent;
  
      if (ruleData.getNodeType() == "ConditionNode") {
        labelComponent = <RuleCondtion nodeInfo={ ruleData }/>
      } else if (ruleData.getNodeType() == "AddNode") {
        labelComponent = <AddRuleNode nodeInfo={ ruleData }/>
      } else if (ruleData.getNodeType() == "StatementNode") {
        labelComponent = <RuleStatement nodeInfo={ ruleData } stepsInfo={stepsInfo} localeCode={localeCode} transIds={translationIds} translations={translations} measurements={measurement_translations}/>
      }
  
      return (
        <StyledTreeItem
          key={ruleData.id}
          nodeId={ruleData.id}
          label={ labelComponent }
          children={children}
        />
      );
    }
  });
}

const DataTreeView = (props) => {
  
  const [expanded, setExpanded] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const [rules, setRules] = React.useState(props.treeItems);
  const [steps, setSteps] = React.useState(props.stepsList);

  useEffect(() => {
    let defaultExpandedId = getDefaultExapndedItem(props.treeItems);
    setExpanded([defaultExpandedId]);
    setSteps(interviewSteps);
  }, []);
  //props.localeCode is in here 

  //only expand if icon was clicked
  const handleToggle = (event, nodeIds) => {
    event.persist()
    let iconClicked = event.target.closest(".MuiTreeItem-iconContainer")
    if(iconClicked) {
      setExpanded(nodeIds);
    }
  };

  //only select if icon wasn't clicked
  const handleSelect = (event, nodeIds) => {
    event.persist()
    let iconClicked = event.target.closest(".MuiTreeItem-iconContainer")
    if(!iconClicked) {
      setSelected(nodeIds);
    }
  };

  const getDefaultExapndedItem = (itemList) => {
    let defaultSelectedItem = "1";

    if (itemList && itemList.length > 0) {
      if (itemList[0] && itemList[0].id) {
        defaultSelectedItem = itemList[0].id;
      }
    }  

    return defaultSelectedItem;
  };

  useEffect(() => {
    console.log("i am updated - DataTreeView - Rules");
  },[rules]);

  const updateRules = (rulesObject, nodeId) => {
    setRules(rulesObject);
    setExpanded([...expanded, nodeId]);
    setSelected([...selected, nodeId]);
  };


  return (
      <GlobalRulesContext.Provider value = {{rules, updateRules, steps}}>
        <TreeView
          defaultExpanded={[getDefaultExapndedItem(props.treeItems)]}
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          defaultEndIcon={<CloseSquare />}
          expanded={expanded}
          selected={selected}
          onNodeToggle={handleToggle}
          onNodeSelect={handleSelect}
        >
          {getTreeItemsFromRules(props.treeItems, props.stepsList, props.localeCode, props.translationIds, props.translations, props.measurement_translations)}
        </TreeView>
      </GlobalRulesContext.Provider>
  );
}

const RulesEditor = (props) => {
  const [t] = useTranslation();
  const riskValues = [t("views.interview.rules_editor.risk_low"),t("views.interview.rules_editor.risk_medium"),t("views.interview.rules_editor.risk_high")];
  const [ruleName, setRuleName] = useState("");
  const [riskValue, setRiskValue] = useState(null);
  const [nextStep, setNextStep] = useState(null);

  const [steps, setSteps] = useState([]);
  const [nextSteps, setNextSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(null);
  const [risks, setRisks] = useState(riskValues);
  const [rulesList, setRulesList] = useState(getRulesData(null));
  const [ruleObject, setRuleObject] = useState(null);
  const [stepElement, setStepElement] = useState(null);
  const [ruleElement, setRuleElement] = useState(null);
  const [focusElement, setFocusElement] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [defaultLocale,setLocale] = useState(props.ruleData.defaultLanguage);
  var locales;

  

  useEffect(() => {
    gRuleCallback = loadRuleDataJson;
  });

  // useEffect(() => {
  //   console.log(nextSteps);
  // }, [nextSteps]);

  useEffect(() => {
    console.log(props);
  }, []);

  const loadRuleDataJson = (step, 
                            steps, 
                            risks, 
                            sensorTypeTable, 
                            ruleObject, 
                            stepElem, 
                            ruleElem, 
                            focusElem) => {
    if (step) {
      setCurrentStep(step);
    }

    setStepElement(stepElem);
    setRuleElement(ruleElem);
    setFocusElement(focusElem);
    
    //TODO: this is where the steps change
    locales = props.ruleData.locales;

    if (steps && step) {
      let filteredSteps = steps.map((aStep) => {
        let theStepInfo = {};
        let measurements = [];
        let choices = [];
        if (aStep.type == "SensorStep") {
          measurements = sensorTypeTable[aStep.sensor_type_id].measurements.filter(aMeasurement => (aMeasurement.label.toLowerCase() != "map" &&
                                                                                                    aMeasurement.label.toLowerCase() != "zwt" &&
                                                                                                    aMeasurement.label.toLowerCase() != "bgc"));
        } 
        else if (aStep.type == "QuestionStep" ||
                   aStep.type == "MultiAnswerQuestionStep") {

          choices = aStep.choices;
        }
       

        theStepInfo = {
          key: uuid(),
          id: aStep.id, 
          step_rule_identifier: aStep.step_rule_identifier,
          label: aStep.content, 
          type: aStep.type,
          choices: choices,
          measurements: measurements
        }
        return theStepInfo;
      });

      interviewSteps = filteredSteps.filter(aStep => (aStep.type == "SensorStep" || 
                                                     aStep.type == "QuestionStep" ||
                                                     aStep.type == "MultiAnswerQuestionStep") );
      let theNextSteps = filteredSteps.filter(aStep => aStep.id != ruleObject.step_id);
      if (theNextSteps && theNextSteps.length > 0 ) {
        let reducedSteps = theNextSteps.map(aStep =>  {return {value: aStep.step_rule_identifier, label:aStep.label}});
        setNextSteps(reducedSteps);
      }
      let stepsForRules = filteredSteps.filter(aStep => (aStep.type == "SensorStep" || 
                                                         aStep.type == "QuestionStep" ||
                                                         aStep.type == "MultiAnswerQuestionStep"));
      setSteps(stepsForRules);
    }

    if (risks) {
      setRisks(risks);
    }

    let ruleName = "";
    let nextStepDetail = null;
    let riskIdDetail = null;
    if (ruleObject ) {
      setRuleObject(ruleObject);
      if (ruleObject.name) {
        ruleName = ruleObject.name;
      } 
      if (ruleObject.next_step_identifier) {
        let theNextStep = steps.find(aStep => aStep.step_rule_identifier == ruleObject.next_step_identifier);
        if(theNextStep) {
          nextStepDetail = {value: theNextStep.step_rule_identifier, label: theNextStep.name};
        }
      }
      if (ruleObject.risk) {
        riskIdDetail =  risks.find(aRisk => aRisk.value == ruleObject.risk);
      }

      if (ruleObject.conditions) {
        setPageTitle("Edit Rule");
      } else {
        setPageTitle("Add Rule");
      }

      let theConditions = getRulesData(ruleObject);
      setRulesList(theConditions);
    }
    setRuleName(ruleName);
    setNextStep(nextStepDetail);
    setRiskValue(riskIdDetail);

  }

  const getLocale = () => {
    const [t] = useTranslation();
    var locale_list = [];
    for(var i=0; i<props.ruleData.locales.length; i++){
      locale_list.push({value: props.ruleData.locales[i], label: t(`languages.${props.ruleData.locales[i]}`)});
    }
    return locale_list;
  }

  const validateRulesData = () => {
    let isSuccess = true;
    if (!nextStep) {
      isSuccess = false;
      alert(t("views.interview.rules_editor.error_next_step"));
    } else if (!ruleName) {
      isSuccess = false;
      alert(t("views.interview.rules_editor.error_rule_name"));
    } else if (!riskValue) {
      isSuccess = false;
      alert(t("views.interview.rules_editor.error_risk_value"));
    }
    return isSuccess;
  }

  const saveRulesList = (event) => {
    resetValidationResult();
    let res = validateRules(rulesList);
    let rulesEngineObject = null;
    if (validateRulesData()) {
      if (res) {
        let obj = getRulesOptions(rulesList[0]);

        rulesEngineObject = {
          id: ruleObject.id,
          step_id: ruleObject.step_id,
          name: ruleName,
          risk: riskValue.value,
          next_step_identifier: nextStep.value,
          conditions: obj,
          position: ruleObject.position
        };

        saveRuleForStep(currentStep, 
                        ruleObject, 
                        rulesEngineObject, 
                        stepElement, 
                        ruleElement); //Global function declared in interview.js
      } else {
        alert(t("views.interview.rules_editor.alerts.incomplete_rule"));
      }
    }
  }

  const cancelRulesEditor = () => {
    cancelRules(); //Global function declared in interview.js
  }

  const handleLocaleChange = (e) => {
    // FUNCTION TO ALTER MOST OF THE TRANSLATIONS
    setLocale(e.value);
    nextStepTranslations(e.value);
  }

  const nextStepTranslations = (lang) => {
    let translations = interviewTranslations(props.ruleData.interview_translations, props.ruleData.interview_translation_ids,lang);
    setNextSteps(extraTranslations(translations, nextSteps));
  }
  const handleNameChange = (event) => {
    setRuleName(event.target.value);
  }

  const onRiskSelect = (risk) => {
    setRiskValue(risk);
  }

  const onNextStepSelect = (theNextStep) => {
    setNextStep(theNextStep);
  }

  return(
    <div className="rules-content">
      <div className="rules-header single-line-container margin-adjust">
        <span className="header-title-section"><h4>{pageTitle}</h4></span>
        <span className="single-line-container action-button">
          <button className="btn btn-success btn-common" onClick={saveRulesList}>Save</button>
          <button className="btn btn-success btn-common" onClick={cancelRulesEditor}>Cancel</button>
        </span>
      </div>
      <div className="conditions-container">
        <div className="single-line-container">
            <label>
              &nbsp; &nbsp; <b>{t("views.interview.rules_editor.name")}</b> &nbsp;  
              <input className="name-field" type="text" value={ruleName} onChange={handleNameChange} name="rule-name"/>
            </label>
            &nbsp; &nbsp; &nbsp; &nbsp;  <b>Risk</b> &nbsp; 
              <Dropdown onChange={onRiskSelect} 
                        options={ risks }
                        value={riskValue}
                        placeholder={t("views.interview.rules_editor.risk")}
                        className="risk-field"/>
            &nbsp; &nbsp; &nbsp;  &nbsp;  <b>Next Step</b> &nbsp;   
            <Dropdown onChange={onNextStepSelect}
                      options={nextSteps}
                      value={nextStep}
                      placeholder={t("views.interview.rules_editor.next_step")}/>
            &nbsp; &nbsp; &nbsp;  &nbsp;  <b>{t("views.interview.rules_editor.language")}</b> &nbsp;   
            <Dropdown options={getLocale()} onChange={handleLocaleChange}></Dropdown>
          </div>

          <div>
            <DataTreeView treeItems={ rulesList } 
                          stepsList={ steps }
                          localeCode={ defaultLocale }
                          translationIds={ props.ruleData.interview_translation_ids }
                          translations={ props.ruleData.interview_translations }
                          measurement_translations={ props.ruleData.measurement_translations }
                          />
          </div>
        </div>

    </div>
  );
}

export default RulesEditor;